import { render } from "./StoreShoppingCartTabbar.vue?vue&type=template&id=1cdf8128&scoped=true"
import script from "./StoreShoppingCartTabbar.vue?vue&type=script&lang=js"
export * from "./StoreShoppingCartTabbar.vue?vue&type=script&lang=js"

import "./StoreShoppingCartTabbar.vue?vue&type=style&index=0&id=1cdf8128&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdf8128"]])

export default __exports__